import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';

@Component({
  selector: 'dojo-app-logo',
  standalone: true,
  template: `
    @if (state.darkMode) {
      <img [src]="iconSrcDark()" [alt]="alt()" [class]="iconClass()" />
    } @else {
      <img [src]="iconSrc()" [alt]="alt()" [class]="iconClass()" />
    }
    @if (!compact()) {
      @if (state.darkMode) {
        <img [src]="logoSrcDark()" [alt]="alt()" class="ml-1.5 w-[82px]" />
      } @else {
        <img [src]="logoSrc()" [alt]="alt()" class="ml-1.5 w-[82px]" />
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex items-center' },
})
export class AppLogoComponent {
  constructor(private readonly colorSchemeService: ColorSchemeService) {}

  readonly iconSrc = input.required<string>();
  readonly iconSrcDark = input.required<string>();
  readonly logoSrc = input.required<string>();
  readonly logoSrcDark = input.required<string>();
  readonly alt = input<string>('ExamDojo');
  readonly iconClass = input<string>('w-[32px]');
  readonly compact = input<boolean>(false);

  readonly state = connectState({
    darkMode: this.colorSchemeService.hasDarkMode$,
  });
}
